import { useEffect } from "react";

const FaviconManager = ({ favicon16, favicon32 }) => {
  useEffect(() => {
    if (!favicon16 && !favicon32) return;

    const updateFavicon = (size, url) => {
      if (!url) return;
      let link = document.querySelector(`link[rel~="icon"][sizes="${size}x${size}"]`);
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        link.type = "image/png";
        link.sizes = `${size}x${size}`;
        document.head.appendChild(link);
      }
      link.href = url;
    };

    // Lade 16x16 favicon in den Speicher und aktualisiere erst, wenn geladen
    if (favicon16) {
      const img16 = new Image();
      img16.src = favicon16;
      img16.onload = () => updateFavicon(16, favicon16);
    }
    // Lade 32x32 favicon in den Speicher und aktualisiere erst, wenn geladen
    if (favicon32) {
      const img32 = new Image();
      img32.src = favicon32;
      img32.onload = () => updateFavicon(32, favicon32);
    }
  }, [favicon16, favicon32]);

  return null;
};

export default FaviconManager;
